import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useContext, useMemo, useState } from 'react';
import { FilterProps } from '../../common/filter.util';
import { Divider, Grid } from '@mui/material';
import { DeleteIcon } from '../../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../../util/color.util';
import { t } from '../../../../../types/translation/Translator';
import MultiSelectionList from '../../../common/MultiSelectionList/MultiSelectionList';
import SearchBar from '../../../common/SearchBar/SearchBar';
import { UserContext } from '../../../../../context/UserContext';
import { UserFilter } from '../UserFilter';

interface UserFilterDropdownContentProps {
  filter: UserFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
  label?: string;
}

export default function UserFilterDropdownContent({
  filter,
  filterProps,
  setFilterProps,
  label = t(TranslationKey.user).singular.label,
}: UserFilterDropdownContentProps) {
  const { companyUsers } = useContext(UserContext);

  const [query, setQuery] = useState<string>('');

  const values = useMemo(() => {
    return new Set([...companyUsers.values()].filter(user => filter.search(user, query)).map(user => user.id));
  }, [query, companyUsers, filter]);

  const handleChange = (selected: Set<string>) => {
    filterProps.user = selected;
    if (!filterProps.user?.size) filterProps.user = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.user = undefined;
    setFilterProps({ ...filterProps });
  };

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-[13px] font-[500] text-gray-500'>{label}</p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setQuery(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          selected={filterProps.user}
          values={values}
          onChange={handleChange}
          toText={id => companyUsers.get(id)?.email}
        />
      </Grid>
    </Grid>
  );
}
